import ReportPage from './components/ReportPage';
import ReportTemplatePage from './components/ReportTemplatePage';
import StatisticsPage from './components/StatisticsPage';

const routes = [
  {
    path: '/statistics',
    name: 'menu.statistics',
    icon: 'graph-down',
    loginRequired: true,
    component: StatisticsPage,
    weight: 3,
    permission: [],
    children: [],
  },
  // {
  //   path: '/report/list',
  //   name: 'menu.report',
  //   icon: 'clipboard-check',
  //   loginRequired: true,
  //   component: ReportPage,
  //   weight: 2,
  //   permission: [],
  //   children: [
  //     {
  //       path: '/report/template',
  //       name: 'menu.report.template',
  //       icon: 'application',
  //       customIcon: true,
  //       loginRequired: true,
  //       component: ReportTemplatePage,
  //       weight: 2,
  //       permission: [],
  //       children: [],
  //     },
  //     {
  //       path: '/report/list',
  //       name: 'menu.report.list',
  //       icon: 'application',
  //       customIcon: true,
  //       loginRequired: true,
  //       component: ReportPage,
  //       weight: 2,
  //       permission: [],
  //       children: [],
  //     },
  //     // {
  //     //   path: '/report/export',
  //     //   name: 'menu.report.export',
  //     //   icon: 'application',
  //     //   customIcon: true,
  //     //   loginRequired: true,
  //     //   component: ReportExportPage,
  //     //   weight: 2,
  //     //   permission: [],
  //     //   children: [],
  //     // },
  //   ],
  // },
];

export default routes;
